<template>
    <div class="row">
        <div class="col-sm-12">
            <h1>Manually Removed Charges</h1>

            <div class="table-responsive" v-loading="loading">
                <table class="table table-striped table-hover">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Employer</th>
                            <th>Driver</th>
                            <th>User</th>
                            <th>Reason</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="l in list">
                            <td>{{ l.date }}</td>
                            <td>
                                <a :href="url(`admin/employer/${l.employer_id}/detail`)">
                                    {{ l.employer_name }}
                                </a>
                            </td>
                            <td>
                                <a :href="url(`admin/driver/${l.driver_id}`)">
                                    {{ l.driver_name }}
                                </a>
                            </td>
                            <td>{{ l.user_name }}</td>
                            <td>{{ l.reason }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <employer-notes-wrapper :employer-id="employer_id" />
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'employer_id'
    ],
    data() {
        return {
            list: [],
            show_dialogs: {
            },
            loading: true
        };
    },
    methods: {
        refresh() {
            this.loading = true;

            return axios.get(url(`admin/reports/manually-removed-charges/data`), {
                params: {
                    employer_id: this.employer_id
                }
            })
            .then((response) => {
                this.list = response.data.list;
                this.loading = false;
            });
        }
    },
    mounted() {
        this.refresh();
    }
}
</script>
